import React from 'react';
import { ShoppingBag } from 'lucide-react';

function TopProductsTable({ products }) {
  if (!products || products.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
        <ShoppingBag className="w-12 h-12 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500 font-montserrat">No hay datos de productos</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
      <div className="max-h-96 overflow-y-auto">
        <table className="w-full">
          <thead className="bg-slate-50 sticky top-0">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 font-montserrat">#</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 font-montserrat">Producto</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 font-montserrat">Cantidad</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 font-montserrat">Pedidos</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {products.map((product, index) => (
              <tr key={product.sku} className="hover:bg-slate-50 transition-colors">
                <td className="px-4 py-3 text-sm font-bold text-[#B1336E] font-montserrat">
                  {index + 1}
                </td>
                <td className="px-4 py-3">
                  <div>
                    <p className="text-sm font-semibold text-slate-900 font-montserrat">
                      {product.title}
                    </p>
                    <p className="text-xs text-slate-500 font-montserrat">{product.sku}</p>
                  </div>
                </td>
                <td className="px-4 py-3 text-right">
                  <span className="inline-flex items-center px-2 py-1 bg-[#67A43C]/10 text-[#67A43C] rounded-full text-sm font-bold font-montserrat">
                    {product.total_quantity}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  <span className="text-sm text-slate-600 font-montserrat">
                    {product.order_count}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TopProductsTable;